import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/**
 * To use this component, the following callback method should be provided:
 * showGridActionComponent(): boolean, default: true
 * getGridActionClass(): css class, default: text-danger
 * execGridAction(): what to do after user clicked on the icon
 * getGridActionIcon(): get grid action icon, default: fas fa-trash-alt fa-lg
 * getGridActionTooltip(): tooltip when mouse hover over the icon
 */
@Component({
  selector: 'pps-grid-action',
  template: `
    <a *ngIf="showGridActionComponent()" class="action-icon p-1 {{getGridActionClass()}}" (click)="execGridAction($event)" href="#">
      <i class="{{getGridActionIcon()}}" title="{{getGridActionTooltip()}}"></i>
    </a>
  `
})
export class GridActionComponent implements AgRendererComponent {
  params: ICellRendererParams;

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  execGridAction(evt){
    evt.preventDefault();
    if (this.params.context.componentParent.execGridAction){
      this.params.context.componentParent.execGridAction(this.params.data);
    }
  }

  getGridActionTooltip(){
    if (this.params.context.componentParent.getGridActionTooltip){
      return this.params.context.componentParent.getGridActionTooltip(this.params.data);
    }

    return "";
  }

  getGridActionIcon(){
    if (this.params.context.componentParent.getGridActionIcon){
      return this.params.context.componentParent.getGridActionIcon(this.params.data);
    }

    return "fas fa-trash-alt fa-lg";
  }

  showGridActionComponent(){
    if (this.params.context.componentParent.showGridActionComponent){
      return this.params.context.componentParent.showGridActionComponent(this.params.data);
    }

    return true;
  }

  getGridActionClass(){
    if (this.params.context.componentParent.getGridActionClass){
      return this.params.context.componentParent.getGridActionClass(this.params.data);
    }

    return "text-danger";
  }
}
